// extracted by mini-css-extract-plugin
export default {"contentHeader":"ResumeClaimSubmission_contentHeader__8WdRL","appleLogo":"ResumeClaimSubmission_appleLogo__eMcK+","resumeClaimSB":"ResumeClaimSubmission_resumeClaimSB__6lecj"};